import { render, staticRenderFns } from "./app_user_order.vue?vue&type=template&id=0c981635&scoped=true&"
import script from "./app_user_order.vue?vue&type=script&lang=js&"
export * from "./app_user_order.vue?vue&type=script&lang=js&"
import style0 from "./app_user_order.vue?vue&type=style&index=0&id=0c981635&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c981635",
  null
  
)

export default component.exports